module.exports = __webpack_public_path__ + "img/close.20138bfc.svg";